import { createContext, useContext } from 'react';

import { Section, Sheet } from '../../validationSchemas/ReportTemplateSchema';

type ReportingHubContextType = {
  activeSheet: Sheet;
  setActiveSheet: Function;
  activeSection: Section;
  setActiveSection: Function;
};

export const ReportingHubContext = createContext<ReportingHubContextType | undefined>(undefined);

export const useReportingHubContext = (): ReportingHubContextType => useContext(ReportingHubContext);
